import gql from 'graphql-tag';
import { questionFieldsFragment } from '@graphql/admin/fragments';

export const addQuestionMutation = gql`
  mutation AddQuestion($input: CreateQuestionInput!) {
    addQuestion(input: $input) {
      ...AdminQuestionFields
    }
  }

  ${questionFieldsFragment}
`;